export const types = <const>{
    actions:{
        BRAND_CHANGE: 'brandChange',
    }
};